<p-dialog 
  [(visible)]="visible"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{width: '90vw', maxWidth: '900px'}"
  [header]="title"
  (onHide)="closeModal()"
  styleClass="video-dialog">
  
  <div class="video-container">
    <iframe 
      *ngIf="visible && safeVideoUrl" 
      [src]="safeVideoUrl" 
      frameborder="0" 
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
      allowfullscreen>
    </iframe>
  </div>
  
  <ng-template pTemplate="footer">
    <p-button 
      label="Continuer" 
      class="pt-4"
      (onClick)="closeModal()" 
      >
    </p-button>
  </ng-template>
</p-dialog>